export interface IColors {
  readonly [key: string]: string;
}

const alias: IColors = {
  BLACK: '#000000',
  BLACK2: '#0B0B0B',
  CHARCOAL: '#4F4F4F',
  DARK_GRAY: '#818181',
  DARK_GRAY2: '#2E2E2E',
  DARK_GRAY3: '#5F5F5F',
  DARK_GRAY4: '#9B9B9B',
  GRAY: '#B0B0B0',
  LIGHT_GRAY: '#DEDEDE',
  LIGHT_GRAY2: '#979797',
  LIGHT_GRAY3: '#2E2E2E',
  LIGHT_GRAY4: '#787878',
  OFF_BLACK: '#1A1A1A',
  RED: '#E80D18',
  WHITE: '#FFFFFF',
  DARK_GREEN: '#48B0A3',
};

export const colors: IColors = {
  black: alias.BLACK,
  black2: alias.BLACK2,
  charcoal: alias.CHARCOAL,
  darkGray: alias.DARK_GRAY,
  darkGray2: alias.DARK_GRAY2,
  darkGray3: alias.DARK_GRAY3,
  darkGray4: alias.DARK_GRAY4,
  error: alias.RED,
  gray: alias.GRAY,
  lightGray: alias.LIGHT_GRAY,
  lightGray2: alias.LIGHT_GRAY2,
  lightGray3: alias.LIGHT_GRAY3,
  lightGray4: alias.LIGHT_GRAY4,
  offBlack: alias.OFF_BLACK,
  red: alias.RED,
  white: alias.WHITE,
  darkGreen: alias.DARK_GREEN,
};
